import iconSize from "./iconSizes";

export const stringToIntConverter = (strValue = "0"): number => {
  try {
    return +strValue.match(/-?\d/g)!.join("");
  } catch (e) {
    return 0;
  }
};

export const iconSizeToIntConverter = (size: keyof typeof iconSize): number => stringToIntConverter(iconSize[size] || "0");
